// PERFORMANCE BOUTIQUE - LUCA BIONDI - JS LOGIC FOR CART UPSELLS

if (!customElements.get('complementary-products')) {
  customElements.define('complementary-products', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.loaded === 'true' || !this.dataset.url) return;
      this.load();
    }

    disconnectedCallback() {
      this.controller?.abort();
    }

    async load() {
      this.controller = new AbortController();
      try {
        const res = await fetch(this.dataset.url, { signal: this.controller.signal });
        if (!res.ok) throw new Error(res.status);
        const doc = new DOMParser().parseFromString(await res.text(), 'text/html');

        const cards = doc.querySelector('template[data-cards]');
        const dots = doc.querySelector('template[data-dots]');
        const list = this.querySelector('[data-list]');

        // Nessun prodotto valido restituito → rimuovo lo shell vuoto
        if (!list || !cards || cards.content.children.length === 0) {
          this.remove();
          return;
        }

        list.appendChild(cards.content.cloneNode(true));

        // Modalità carousel: il contenitore stesso è lo <scroll-carousel>
        if (list.tagName.toLowerCase() === 'scroll-carousel') {
          this.reinit(list); // ricalcola le pagine con le card iniettate
          const nav = this.querySelector('carousel-navigation');
          if (nav && dots && dots.content.children.length) {
            nav.appendChild(dots.content.cloneNode(true));
            nav.hidden = false;
            this.reinit(nav); // ri-aggancia i dots al carousel
          }
        }

        this.dataset.loaded = 'true';
        this.hidden = false;
      } catch (err) {
        if (err.name !== 'AbortError') this.remove();
      }
    }

    // Sostituisce un custom element con un clone, così il suo connectedCallback
    // viene rieseguito con i figli già presenti (carousel/dots inizializzati correttamente)
    reinit(el) {
      const clone = el.cloneNode(true);
      el.replaceWith(clone);
      return clone;
    }
  });
}